// extracted by mini-css-extract-plugin
export var active = "_eg-7";
export var container = "_eg-0";
export var evenWidth = "_eg-4";
export var large = "_eg-5";
export var outlet = "_eg-8";
export var slide = "_eg-2";
export var small = "_eg-6";
export var tab = "_eg-3";
export var tabs = "_eg-1";